import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import Cropper from "react-cropper";
import { Button } from "reactstrap";
import "canvas-toBlob";
import 'cropperjs/dist/cropper.css';
import { getTransFunc } from '../SFxLocalization';
import Modal from "../Modal";
import CommonLoad from "../Spin";

var prefix = "sfx-avatar";

function imageCompression(baseImage, obj, quality, callback) {
  var img = new Image();
  img.src = baseImage;

  img.onload = function () {
    var width = img.width,
        height = img.height;
    var w = width;
    var h = height;
    var compressionResult;

    if (h > obj.height) {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var canvasW = document.createAttribute("width");
      var canvasH = document.createAttribute("height");
      h = obj.height;
      w = obj.height / height * w;
      canvasW.nodeValue = "".concat(w, "px");
      canvasH.nodeValue = "".concat(h, "px");
      canvas.setAttributeNode(canvasW);
      canvas.setAttributeNode(canvasH);
      ctx && ctx.drawImage(img, 0, 0, w, h);
      var base64 = canvas.toDataURL("image/png", quality);
      compressionResult = base64;
    } else {
      compressionResult = baseImage;
    }

    callback(compressionResult);
  };
}

var Avatar = /*#__PURE__*/function (_Component) {
  _inherits(Avatar, _Component);

  var _super = _createSuper(Avatar);

  function Avatar() {
    var _this;

    _classCallCheck(this, Avatar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "cropperElement", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      avatarImg: "",
      preview: "",
      previewCanvas: null,
      resultImg: "",
      imgName: "",
      imgBefore: "",
      errorMsg: "",
      isError: false,
      isDisable: false,
      showSaveLoading: false,
      trans: getTransFunc()
    });

    _defineProperty(_assertThisInitialized(_this), "limitImageSize", function (fileData, callback) {
      var isAllow = true;
      var minWidth = 500; //500px

      var minHeight = 500; //500px

      var reader = new FileReader();

      reader.onload = function (e) {
        var data = e.target && e.target.result;
        var image = new Image();

        image.onload = function () {
          var width = image.width;
          var height = image.height;
          isAllow = width >= minWidth && height >= minHeight;

          if (callback) {
            callback(isAllow);
          }
        };

        if (data) {
          image.src = data.toString();
        }
      };

      reader.readAsDataURL(fileData);
    });

    _defineProperty(_assertThisInitialized(_this), "initImg", function () {
      var currentImg = _this.props.currentImg;

      if (currentImg) {
        var arr = currentImg.split("/");
        var imgName = arr && arr[arr.length - 1];

        _this.setState({
          resultImg: currentImg,
          imgBefore: currentImg,
          imgName: imgName
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fileHandler", function (state) {
      var trans = _this.state.trans;

      _this.setState({
        isDisable: false
      });

      var avatarElement = document.getElementById("avatar_file");
      var avatarElement1 = document.getElementById("avatar_file_1");
      var avatarElementFiles = avatarElement && avatarElement.files && avatarElement.files[0];
      var avatarElement1Files = avatarElement1 && avatarElement1.files && avatarElement1.files[0];
      var fileObj = avatarElementFiles || avatarElement1Files;
      if (avatarElement) avatarElement.value = "";
      if (avatarElement1) avatarElement1.value = "";
      var windowURL = window.URL || window.webkitURL;

      if (fileObj) {
        _this.limitImageSize(fileObj, function (isAllow) {
          if (!isAllow) {
            _this.setState({
              isError: true,
              errorMsg: trans('SFxAvatarLimitSizeErrorMsg')
            });

            return;
          } else {
            _this.setState({
              isError: false,
              errorMsg: ""
            });
          }

          if (state === "edit") {
            _this.setState({
              resultImg: ""
            });
          }

          var dataURl = windowURL.createObjectURL(fileObj);

          _this.setState({
            avatarImg: dataURl,
            imgName: fileObj.name
          }, function () {
            if (_this.props.state) _this.props.state("edit");
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCloseErrorTip", function () {
      _this.setState({
        isError: false,
        errorMsg: ""
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onImageChange", function () {
      if (!_this.cropperElement) {
        return;
      }

      var cropper = _this.cropperElement.cropper;

      if (cropper !== null) {
        var imgCanvas = cropper.getCroppedCanvas();
        var img = imgCanvas.toDataURL();
        imageCompression(img, {
          width: 500,
          height: 500
        }, 1, function (res) {
          _this.setState({
            preview: res,
            previewCanvas: imgCanvas
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      if (_this.props.state) _this.props.state('');

      if (_this.state.imgBefore) {
        _this.setState({
          resultImg: _this.state.imgBefore
        });
      } else {
        _this.setState({
          resultImg: "",
          avatarImg: "",
          preview: "",
          imgName: ""
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSavePhoto", function () {
      _this.setState({
        isDisable: true,
        showSaveLoading: true
      });

      var upLoadImg = _this.props.upLoadImg;
      var _this$state = _this.state,
          previewCanvas = _this$state.previewCanvas,
          preview = _this$state.preview,
          trans = _this$state.trans;
      previewCanvas.toBlob( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blob) {
          var blobImg, res;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  blobImg = new File([blob], "avatar.png");

                  if (!upLoadImg) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 4;
                  return upLoadImg(blobImg);

                case 4:
                  res = _context.sent;

                  if (res) {
                    _this.setState({
                      resultImg: preview,
                      imgBefore: preview,
                      errorMsg: "",
                      showSaveLoading: false,
                      isError: false
                    });
                  } else {
                    _this.setState({
                      errorMsg: trans('SFxAvatarUploadAvatarErrorMsg'),
                      isError: true,
                      showSaveLoading: false,
                      isDisable: false
                    });
                  }

                  if (_this.props.state) _this.props.state('');
                  _context.next = 10;
                  break;

                case 9:
                  _this.setState({
                    resultImg: preview,
                    imgBefore: preview,
                    errorMsg: "",
                    showSaveLoading: false,
                    isError: false
                  });

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "deleteAvatar", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, deleteImg, currentImg, trans, res;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                resultImg: "",
                avatarImg: "",
                preview: "",
                imgName: "",
                imgBefore: "",
                errorMsg: "",
                isError: false
              });

              _this$props = _this.props, deleteImg = _this$props.deleteImg, currentImg = _this$props.currentImg;
              trans = _this.state.trans;

              if (!(deleteImg && currentImg)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return deleteImg(currentImg);

            case 6:
              res = _context2.sent;

              if (!res) {
                _this.setState({
                  errorMsg: trans('SFxAvatarDeleteAvatarErrorMsg'),
                  isError: true
                });
              }

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "onDelete", function () {
      _this.setState({
        isDisable: false
      });

      _this.showConfirm(_this.deleteAvatar);
    });

    _defineProperty(_assertThisInitialized(_this), "showConfirm", function (onOKCallback, onCancelCallback, onCloseCallback) {
      var trans = _this.state.trans;
      Modal.confirm({
        title: trans('SFxAvatarDeleteAvatar'),
        content: trans('SFxAvatarDeleteAvatarInfo'),
        okText: trans('SFxAvatarDelete'),
        cancelText: trans('SFxAvatarCancel'),
        centered: true,
        onOk: function onOk() {
          if (onOKCallback) onOKCallback();
        },
        onClose: function onClose() {
          if (onCloseCallback) onCloseCallback();
        },
        onCancel: function onCancel() {
          if (onCancelCallback) onCancelCallback();
        }
      });
    });

    return _this;
  }

  _createClass(Avatar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initImg();
      var _this$props2 = this.props,
          onRef = _this$props2.onRef,
          transInstance = _this$props2.transInstance;

      if (onRef) {
        onRef(this);
      }

      if (transInstance) {
        this.setState({
          trans: getTransFunc(transInstance)
        });
      }
    }
  }, {
    key: "renderDom",
    value: function renderDom() {
      var _this2 = this;

      var _this$props3 = this.props,
          width = _this$props3.width,
          height = _this$props3.height,
          readonly = _this$props3.readonly;
      var _this$state2 = this.state,
          isError = _this$state2.isError,
          resultImg = _this$state2.resultImg,
          preview = _this$state2.preview,
          avatarImg = _this$state2.avatarImg,
          showSaveLoading = _this$state2.showSaveLoading,
          trans = _this$state2.trans;
      var errorMsgDom = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatar-error")
      }, this.state.errorMsg, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-avatar-error-close"),
        onClick: this.onCloseErrorTip
      }));
      var styleObj = readonly ? {
        display: 'none'
      } : {};

      var rightDom = function rightDom(state) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefix, "-avatarWrapBox-editor-wrap")
        }, _this2.props.children, /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefix, "-avatarWrapBox-editor-chose")
        }, /*#__PURE__*/React.createElement("span", null, trans('SFxAvatarChoseImageInfo')), " ", trans('SFxAvatarOptional'), /*#__PURE__*/React.createElement("input", {
          className: "".concat(prefix, "-fileInput"),
          id: "avatar_file_1",
          type: "file",
          onChange: function onChange() {
            _this2.fileHandler(state);
          },
          accept: ".jpg,.jpeg,.png,.gif,.bmp"
        })), /*#__PURE__*/React.createElement("p", {
          className: "".concat(prefix, "-avatarWrapBox-editor-info")
        }, trans('SFxAvatarSuggestImageSizeInfo')));
      };

      var initialDom = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatarWrapBox-wrap")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatarWrapBox"),
        style: {
          width: "".concat(this.props.width || 290, "px"),
          height: "".concat(this.props.height || 290, "px")
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatarCircle")
      }, /*#__PURE__*/React.createElement("div", {
        style: styleObj,
        className: "".concat(prefix, "-uploadImg")
      }), /*#__PURE__*/React.createElement("input", {
        style: styleObj,
        className: "".concat(prefix, "-fileInput"),
        id: "avatar_file",
        type: "file",
        onChange: function onChange() {
          _this2.fileHandler();
        },
        accept: ".jpg,.jpeg,.png,.gif,.bmp"
      }))), rightDom());
      var resultDom = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatarWrapBox-wrap")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-avatarWrapBox-img"),
        style: {
          width: "".concat(width || 290, "px"),
          height: "".concat(height || 290, "px")
        }
      }, /*#__PURE__*/React.createElement("img", {
        className: "".concat(prefix, "-result-img"),
        src: resultImg
      }), /*#__PURE__*/React.createElement("img", {
        className: "".concat(prefix, "-result-img-face"),
        src: resultImg
      }), /*#__PURE__*/React.createElement("span", {
        style: styleObj
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefix, "-avatar-delete-icon"),
        onClick: this.onDelete
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-result-img-edit")
      }), /*#__PURE__*/React.createElement("input", {
        className: "".concat(prefix, "-fileInput-edit"),
        id: "avatar_file",
        type: "file",
        onChange: function onChange() {
          _this2.fileHandler("edit");
        },
        accept: ".jpg,.jpeg,.png,.gif,.bmp"
      }))), rightDom("edit"));
      var editDom = /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-image-wrap")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-image-cut-panel")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-image-cut")
      }, showSaveLoading && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-image-save-loading-panel")
      }, /*#__PURE__*/React.createElement(CommonLoad, {
        size: 0.2
      })), /*#__PURE__*/React.createElement(Cropper, {
        ref: function ref(node) {
          return _this2.cropperElement = node;
        },
        src: avatarImg,
        style: {
          height: 379,
          width: width && width * 2.2 || 505
        },
        aspectRatio: 1,
        viewMode: 1,
        crop: this.onImageChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-image-cut-panel-btn-area")
      }, /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        disabled: this.state.isDisable,
        onClick: this.onCancel
      }, trans('SFxAvatarCancel')), /*#__PURE__*/React.createElement(Button, {
        size: "sm",
        color: "primary",
        disabled: this.state.isDisable,
        onClick: this.onSavePhoto
      }, trans('SFxAvatarSavaPhoto')))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-image-preview-wrap")
      }, /*#__PURE__*/React.createElement("img", {
        className: "".concat(prefix, "-image-preview"),
        src: preview
      }), /*#__PURE__*/React.createElement("img", {
        className: "".concat(prefix, "-image-preview-face"),
        src: preview
      })));
      return /*#__PURE__*/React.createElement(React.Fragment, null, isError && errorMsgDom, resultImg ? resultDom : avatarImg ? editDom : initialDom);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderDom();
    }
  }]);

  return Avatar;
}(Component);

export default Avatar;